export default "__VITE_ASSET__28ed4633__"